import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Krishna Kasyap Kanuparthi </span>
            from <span className="purple"> Andhra Pradesh, India.</span>
            <br />
            I have completed B.tech in Computer Science and Engineering From Swarnandhra College of Engineering and Technology
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "life doesn't has Ctrl+Z"{" "}
          </p>
          <footer className="blockquote-footer">Krishna kasyap</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
